import PropTypes from 'prop-types';
import React from 'react';

import Headline from '../../atoms/headline/headline';
import Image from '../../atoms/image/image';
import Link from '../../atoms/link/link';
import StyledAuthor from './author.style';

import TwitterIcon from '../../icons/twitterBorder.svg';
import EmailLink from '../emailLink/emailLink';

const Author = props => {
  const { fullName, email, twitterProfile, avatar, authorCategory } = props;
  return (
    <StyledAuthor {...props}>
      <div className="author__wrapper">
        <div className="author">
          <div className="author__content">
            {authorCategory && (
              <Headline tag="p" subline>
                {authorCategory.map(category => category.title)}
              </Headline>
            )}
            <Headline tertiary tag="h3" className="author__name">
              {fullName}
            </Headline>

            {twitterProfile && (
              <Link
                href={twitterProfile}
                target="_blank"
                rel="noopener noreferrer"
                className="author__contact"
              >
                <TwitterIcon width="25" height="25" />
                <span>{twitterProfile.replace(/^https?:\/\//, '')}</span>
              </Link>
            )}

            {email && (
              <EmailLink
                encodedEmail={email}
                className="author__contact"
                iconWidth={25}
                iconHeight={25}
              />
            )}
          </div>

          {avatar && (
            <div className="author__image">
              <Image
                {...avatar}
                lazy="default"
                sizes={[
                  {
                    width: '170px'
                  }
                ]}
              />
            </div>
          )}
        </div>
      </div>
    </StyledAuthor>
  );
};

Author.propTypes = {
  fullName: PropTypes.string.isRequired,
  email: PropTypes.string,
  twitterProfile: PropTypes.string,
  avatar: PropTypes.shape(),
  authorCategory: PropTypes.arrayOf(PropTypes.shape())
};

export default Author;
